import CmsApiFactory from "@/services/CmsApiFactory.js";

export default {
    async getHotDestination() {
        let res = await CmsApiFactory.get("/common/destination?stage=PUBLISH");
        return res.data;
    },
    async getHotDestinationDetail(params) {
        let res = await CmsApiFactory.get("/common/destination/" + params + "?stage=PUBLISH");
        return res.data;
    },
    async getMainBanner() {
        let res = await CmsApiFactory.get("/common/banner?stage=PUBLISH");
        return res.data;
    },
    async postCustomCarQuery(params) {
        let res = await CmsApiFactory.post("/enquiry/carRentalEnquiry/add", params);
        return res.data;
    },
    async getCarRentalSummary() {
        let res = await CmsApiFactory.get("/car/carRentalSummary?stage=PUBLISH");
        return res.data;
    },
    async getCarRentalService(param) {
        let res = await CmsApiFactory.get("/car/carRentalService/" + param + "?stage=PUBLISH");
        return res.data;
    },
    async getFaqTitle() {
        let res = await CmsApiFactory.get("/website/faq?stage=PUBLISH");
        return res.data;
    },
    async getFaq(param) {
        let res = await CmsApiFactory.get("/website/faq/" + param + "?stage=PUBLISH");
        return res.data;
    },
    async getPartnership() {
        let res = await CmsApiFactory.get("/website/cooperationIntro?stage=PUBLISH");
        return res.data;
    },
    async postCooperation(params) {
        let res = await CmsApiFactory.post("/enquiry/cooperationEnquiry/add", params);
        return res.data;
    },
    async getRecommendations() {
        let res = await CmsApiFactory.get("/common/gpickArticle?stage=PUBLISH");
        return res.data;
    },
    async getRecommendationDetail(param) {
        let res = await CmsApiFactory.get("/common/gpickArticle/" + param);
        return res.data;
    },
    async getMarquee() {
        let res = await CmsApiFactory.get("/common/marquee?stage=PUBLISH");
        return res.data;
    }
}